import { utcDateTimeToLocalString } from 'helpers/dateTimeHelper'
import { utcToLocalDateTimeFormat } from 'helpers/dateTimeHelper'
import { isoToLocaleFormat } from 'helpers/dateTimeHelper'
import React from 'react'
import FormLabel from '../form/FormLabel'

const DatePicker = React.forwardRef(
  ({ name, maxDate, selectedDate, onChange, label, isRequired, isHorizontal = false }, ref) => (
    <div className={`${isHorizontal ? "flex space-x-2 " : ""}w-full mb-1`}>
      <FormLabel label={label ?? name} isRequired={isRequired} className={isHorizontal ? "text-xs font-medium shrink-0 self-center mb-0" : ""}/>
      <input
        type="date"
        max={maxDate}
        value={selectedDate}
        name={name}
        className="px-2 form-control"
        onChange={(e) => {
          onChange(e.target.value)
        }}
        ref={ref}
      />
    </div>
  ),
)

// const DatePicker = ({
//   name,
//   maxDate,
//   selectedDate,
//   onChange,
//   label,
//   isRequired,
// }) => {
//   return (
//
//   )
// }
//
const DateTimePicker = ({
  name,
  maxDate,
  selectedDate,
  onChange,
  label,
  isRequired,
  disabled = false,
  isHorizontal = false,
  convertToUTC = false
}) => {
  const handleInputClick = (event) => {
    const now = new Date().toISOString().slice(0, 16)
    event.target.min = now
  }

  return (
    <div className={`${isHorizontal ? "flex space-x-2 " : ""}w-full mb-4`}>
      <FormLabel label={label ?? name} isRequired={isRequired} className={isHorizontal ? "text-xs font-medium shrink-0 self-center mb-0" : ""} />
      <input
        type="datetime-local"
        max={maxDate}
        step={60}
        value={convertToUTC ? utcToLocalDateTimeFormat(selectedDate) : selectedDate}
        name={name}
        className="px-2 form-control"
        onChange={(e) => {
          if(convertToUTC){
            onChange(new Date(e.target.value).toISOString().slice(0,19).replace("Z", ""))
          }else{
            onChange(e.target.value);
          }
        }}
        disabled={disabled}
        onClick={handleInputClick}
      />
    </div>
  )
}

export default DatePicker

export { DateTimePicker }
